import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=7639209e&scoped=true&lang=pug&"
import script from "./Rankings.vue?vue&type=script&lang=js&"
export * from "./Rankings.vue?vue&type=script&lang=js&"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=7639209e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639209e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup,VListItemSubtitle,VProgressCircular})
